import Tree from "assets/img/landing/tree.png";
import Crop from "assets/img/landing/crop.png";
import Forest from "assets/img/landing/forest.png";
import Image from "next/image";
import { useTranslation } from "react-i18next";

function index() {
  const { t, i18n } = useTranslation();

  const data = [
    {
      img: Tree,
      title: "Tree Farming",
      description:
        "A comprehensive palm tree farm management platform, as single sign-on platform. It cater the needs to control and monitor water and fertilizer use, real-time updates on field and crop health, automatic summary reports, etc. It is adapted and personalized based on the context of palm tree farms.",
    },
    {
      img: Forest,
      title: "Forest & Lakes Monitoring",
      description:
        "Our monitoring solution enables sustainable forest and water management focusing on managing vegetation, restoring ecosystems, reducing hazards, and maintaining forest health.",
    },
    {
      img: Crop,
      title: "Crop Farming",
      description:
        "A comprehensive pivot management platform, as single sign-on platform. It cater the needs to control and monitor water and fertilizer use, real-time updates on field and crop health, automatic summary reports, etc. It is adapted and personalized based on the context of pivot farms.",
    },
  ];

  return (
    <div className="m-auto py-15 contaiter " id="WhatWeServe">
      <div className="mx-5 md:mx-0">
        <div className="text-3xl font-bold text-center ">
          {t("FARMING TYPES that we serve")}
        </div>
        <div
          className={`px-5 mt-15 gap-2 grid grid-cols-1   lg:grid-cols-3 text-center md:text-left justify-center items-start ${
            i18n.language === "en" ? "md:text-left" : "md:text-right"
          } `}
        >
          {data.map((i) => (
            <div
              key={i.title}
              className="flex items-center justify-center w-full gap-2 lg:items-start"
            >
              <div>
                <Image className="sm:w-[25%]" src={i.img} alt="img" />
              </div>
              <div className={`w-72 sm:w-64 lg:w-72  `}>
                <div className="font-bold text-[20px]"> {t(i.title)}</div>
                <div className="text-[#717171] text-[15px] md:text-[13px] 2xl:text-[18px] mb-5 md:mb-0">
                  {t(i.description)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default index;
